export default __webpack_public_path__ + "static/media/Linkedin.85256ce9.svg";